import React, { useEffect, useState } from 'react';
// import { api } from '../../../redux/setupAxios';
import Phone from '../Phone/Phone';
import { ReactComponent as Arrow } from './chevron-right-solid.svg';
import { ReactComponent as TooltipIcon } from './tooltip.svg';
import { Prompt } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { actions as merchantsActions } from '../../../redux/merchants/index'
import { updateSettings } from '../../helper/updateSettings';

const Visibility = () => {
	const { merchantId, merchantOptions, allMerchants } = useSelector(
		state => ({
			merchantId: state.auth.user.merchantId,
			merchantOptions: state.merchants.merchants[0].options,
			allMerchants: state.merchants.merchants,
		}),
	);
	const currentMerchant = allMerchants.find(merchant => merchant.merchantId === merchantId)

	const dispatch = useDispatch();
	const defaultSettings = {
		isEnabled: false,
		handletext: '',
		brandColor: '',
		handledesign: 'square',
		handlePositionPercent: 0,
		handlePositionDesktopPercent: 0,
		zIndex: 0,
		hideAfterSeveralVisits: false,
		hideOnVisit: 0,
		hideOnScroll: false,
	}
	const [isBlocking, setIsBlocking] = useState(false);
	const [loading, setLoading] = useState(false);
	const [alert, setAlert] = useState({
		display: false,
		message: '',
		type: '',
	});

	const [selected, setSelected] = useState('section1');
	const [settings, setSettings] = useState({});

	useEffect(() => {
		setSettings(merchantOptions);
	}, [merchantOptions]);

	const saveSettings = async () => {
		try {
			setAlert({ display: false });
			setLoading(true)
			currentMerchant.options = { ...currentMerchant.options, ...settings }
			await updateSettings(currentMerchant, merchantId);
			setLoading(false)
			setAlert({ display: true, message: 'Data saved successfully', type: 'primary' });
			setIsBlocking(false);
			dispatch(merchantsActions.setMerchants([currentMerchant]));
		} catch (error) {
			console.error(error);
		}
	};

	const handleChange = e => {
		if (e.target.type === 'checkbox') {
			setSettings({ ...settings, [e.target.name]: !settings[e.target.name] });
		} else {
			if (e.target.name === 'handlePositionPercent' || e.target.name === 'handlePositionDesktopPercent') {
				e.target.value = e.target.value > 100 ? 100 : e.target.value;
				setSettings({ ...settings, [e.target.name]: e.target.value });
			} else if (e.target.name === 'hideOnVisit') {
				e.target.value = e.target.value < 0 ? 0 : e.target.value > 10 ? 10 : e.target.value;
				setSettings({ ...settings, [e.target.name]: e.target.value });
			} else {
				setSettings({ ...settings, [e.target.name]: e.target.value });
			}
		}
		setIsBlocking(true);
	};

	return (
		<>
			<div className='page-wrapper'>
				<Prompt
					when={isBlocking}
					// message={location => `Are you sure you want to go to ${location.pathname}`}
					message={location => `Save your modification?`}
				/>
				<div className='col-xxl-5'>
					<div className='card-visibility'>
						<div className='card-vi-header'>
							<span className='fw-bold text-dark'>Visibility</span>
						</div>
						<div className='card-body-visibility'>
							<div className='bah-accordion'>
								<div className='bah-accordion__element bah-border'>
									{alert.display && (
										<div
											profile='alert'
											className={`mb-10 alert alert-custom alert-light-${alert.type} alert-dismissible`}
										>
											<div className='alert-text font-weight-bold'>{alert.message}</div>
										</div>
									)}
									<input
										id='section1'
										type='radio'
										className='bah-accordion__element__check'
										checked={selected === 'section1'}
										onChange={() => { }}
									/>
									<label
										htmlFor='section1'
										className='bah-accordion__element__header fw-bold label-vi'
										onClick={() =>
											setSelected(old => (old === 'section1' ? 'section2' : 'section1'))
										}
									>
										Main options
										<Arrow className='arrow-icon' />
									</label>
									<div className='bah-accordion__element__content'>
										<div className='content-wrapper'>
											<label className='input-label'>Enable Squadded</label>
											<span className='switch switch-icon'>
												<label className='switch-label'>
													<input
														type='checkbox'
														name='isEnabled'
														value='isEnabled'
														checked={settings.isEnabled || defaultSettings.isEnabled}
														onClick={handleChange}
														onChange={() => { }}
													/>
													<span className='checkbox-input'></span>
												</label>
											</span>
										</div>
										<div className='content-wrapper'>
											<label className='input-label'>Your name for the solution</label>
											<input
												type='text'
												className='form-control form-control-lg form-control-solid content-input'
												placeholder='Type your store name...'
												name='handletext'
												value={settings.handletext || defaultSettings.handletext}
												onChange={handleChange}
											/>
											<span className='name-remember'>The best names are easy to remember</span>
										</div>
										<div className='content-wrapper'>
											<label className='input-label'>Your main color</label>
											<div className='color-input'>
												<input
													type='color'
													className='color-box field-radio'
													id='visi_primary_color'
													name='brandColor'
													value={settings.brandColor || defaultSettings.brandColor}
													onChange={handleChange}
												/>
											</div>
											<span className='name-remember'>
												This main color will define buttons and icons inside the panel
											</span>
										</div>
										<div className='content-wrapper'>
											<label className='input-label'>Handle type</label>
											<div className='handle-wrapper'>
												<input
													className='form-check-input input-radio'
													id='radio1'
													type='radio'
													name='handledesign'
													value='square'
													checked={settings.handledesign === 'square'}
													onChange={handleChange}
												/>
												<label htmlFor='radio1'>Handle</label>
											</div>
											<div className='handle-wrapper'>
												<input
													className='form-check-input input-radio'
													id='radio2'
													type='radio'
													value='circle'
													name='handledesign'
													checked={settings.handledesign === 'circle'}
													onChange={handleChange}
												/>
												<label htmlFor='radio2'>Button</label>
											</div>
										</div>
									</div>
								</div>
								<div className='bah-accordion__element'>
									<input
										id='section2'
										name='test-accordion'
										type='radio'
										className='bah-accordion__element__check'
										checked={selected === 'section2'}
										onChange={() => { }}
									/>
									<label
										htmlFor='section2'
										className='bah-accordion__element__header fw-bold label-vi'
										onClick={() =>
											setSelected(old => (old === 'section1' ? 'section2' : 'section1'))
										}
									>
										Advanced options <Arrow className='arrow-icon' />
									</label>
									<div className='bah-accordion__element__content'>
										<div className='content-wrapper'>
											<div className='container-input'>
												<label className='input-label'>
													Position on mobile
													<div className='tooltips'>
														<TooltipIcon />
														<span className='tooltiptexts'>
															Explanation of what position on desktop means
														</span>
													</div>
												</label>
												<div className='input-group'>
													<div className='input-group-prepend'>
														<span className='input-group-text input-control-span'>%</span>
													</div>
													<input
														type='number'
														className='form-control input-control'
														name='handlePositionPercent'
														value={settings.handlePositionPercent || defaultSettings.handlePositionPercent}
														onChange={handleChange}
													/>
												</div>
											</div>
											<div className='container-input'>
												<label className='input-label'>
													Position on desktop
													<div className='tooltips'>
														<TooltipIcon />
														<span className='tooltiptexts'>
															Explanation of what position on desktop means
														</span>
													</div>
												</label>
												<div className='input-group'>
													<div className='input-group-prepend'>
														<span className='input-group-text input-control-span'>%</span>
													</div>
													<input
														type='number'
														className='form-control input-control'
														name='handlePositionDesktopPercent'
														value={settings.handlePositionDesktopPercent || defaultSettings.handlePositionDesktopPercent}
														onChange={handleChange}
													/>
												</div>
											</div>
											<div className='container-input'>
												<label className='input-label'>
													zIndex
													<div className='tooltips'>
														<TooltipIcon />
														<span className='tooltiptexts'>
															Explanation of what position on desktop means
														</span>
													</div>
												</label>
												<div className='input-group'>
													<input
														type='number'
														className='form-control input-control'
														name='zIndex'
														value={settings.zIndex || defaultSettings.zIndex}
														onChange={handleChange}
													/>
												</div>
											</div>
											<div className='container-input'>
												<label className='input-label'>
													Hide after several visits
													<div className='tooltips'>
														<TooltipIcon />
														<span className='tooltiptexts'>
															Explanation of what position on desktop means
														</span>
													</div>
												</label>
												<span className='switch switch-icon'>
												</span>
												<span className='name-remember'>How many visits until it hides</span>
												<div className='input-group'>
													<input
														type='number'
														className='form-control input-control'
														name='hideOnVisit'
														value={settings.hideOnVisit || defaultSettings.hideOnVisit}
														onChange={handleChange}
													/>
												</div>
											</div>
											<div className='container-input'>
												<label className='input-label'>
													Hide on scroll
													<div className='tooltips'>
														<TooltipIcon />
														<span className='tooltiptexts'>
															Explanation of what position on desktop means
														</span>
													</div>
												</label>
												<span className='switch switch-icon'>
													<label className='switch-label'>
														<input
															type='checkbox'
															name='hideOnScroll'
															value='hideOnScroll'
															checked={settings.hideOnScroll}
															onClick={handleChange}
															onChange={() => { }}
														/>
														<span className='checkbox-input'></span>
													</label>
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className='my-4 save-btn-wrapper'>
						<button className='btn btn-dark' onClick={saveSettings}>
							{loading ?
								<>
									<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
								</>
								:
								<>
									Publish
								</>
							}
						</button>
					</div>
				</div>
				<Phone />
			</div>
		</>
	);
};

export default Visibility;
